import styled from 'styled-components'

const StyledCartHeader = styled.header`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool250};
  display: flex;
  padding: 10px 15px;
  justify-content: space-between;
`

export default StyledCartHeader
